import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';

import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <div className='h-full min-h-0'>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position='top-right' />
    </div>
  );
}

export default App;
